export default __webpack_public_path__ + "static/media/9N.c978741b.jpg";